export const ENTIRE_SCREEN_REQUIRED_MESSAGE =
  "Please select Entire Screen only. Chrome Tab or Window sharing is not allowed for this assessment.";

export function stopMediaStream(stream) {
  stream?.getTracks?.().forEach((track) => {
    try {
      track.stop();
    } catch (error) {
      console.warn("Unable to stop media track:", error);
    }
  });
}

export function ensureEntireScreenSelected(stream) {
  const videoTrack = stream?.getVideoTracks?.()[0];
  const displaySurface = videoTrack?.getSettings?.().displaySurface;

  if (displaySurface && displaySurface !== "monitor") {
    stopMediaStream(stream);
    const error = new Error(ENTIRE_SCREEN_REQUIRED_MESSAGE);
    error.code = "ENTIRE_SCREEN_REQUIRED";
    error.displaySurface = displaySurface;
    throw error;
  }

  return stream;
}
